import React from 'react';
import '../styles/ContactForm.css';

interface StatusMessageProps {
  message: string;
  type: 'success' | 'error';
  id?: string;
}

const StatusMessage: React.FC<StatusMessageProps> = ({ message, type, id }) => {
  return (
    <div 
      id={id}
      className={`status-message ${type}`}
      role="alert"
      aria-live="polite"
    >
      {message}
    </div>
  );
};

export default StatusMessage;

